import { render } from "./EditCasierPage.vue?vue&type=template&id=2c65c9e9&ts=true"
import script from "./EditCasierPage.vue?vue&type=script&lang=ts"
export * from "./EditCasierPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__